
class Contacto{
    
    static labelDefinirNuevoContacto = "Definir Nuevo";

    static crearContactoDefinirNuevo(){
        return new Contacto(
            Contacto.labelDefinirNuevoContacto,
            "",
            "",
            "",
            "",
            "",
        );
    }
    static iniciarlizarContactoDefinirNuevo(contacto){
        contacto.nombre= Contacto.labelDefinirNuevoContacto;
        contacto.rol= "";
        contacto.telcel1= "";
        contacto.telcel2= "";
        contacto.telfijo= "";
        contacto.email= "";
    }

    constructor(nombre,rol,telcel1,telcel2,telfijo,email){
             this.nombre= nombre;
            //  this.nombre= "Definir Nuevo";
             this.rol= rol;
             this.telcel1= telcel1;
             this.telcel2= telcel2;
             this.telfijo= telfijo;
             this.email= email;
    }

                    
}

export default Contacto;